/**
 * 361 Sleep — Section 4 carousel (Swiper, RTL, 3 cards)
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function whenSwiper(fn) {
    if (window.Swiper) {
      fn(window.Swiper);
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (window.Swiper) {
        clearInterval(timer);
        fn(window.Swiper);
      } else if (tries > 80) {
        clearInterval(timer);
      }
    }, 50);
  }

  function initCarousel(root, Swiper) {
    var el = root.querySelector('.allinone361__swiper');
    if (!el || el.swiper) return;

    var prev = root.querySelector('[data-allinone-prev]');
    var next = root.querySelector('[data-allinone-next]');

    var swiper = new Swiper(el, {
      /* Mobile: 1 full card + half of the next */
      slidesPerView: 1.5,
      spaceBetween: 14,
      speed: 650,
      grabCursor: true,
      watchOverflow: true,
      resistanceRatio: 0.65,
      /* Design: 2 full cards + a small peek of the third */
      breakpoints: {
        750: {
          slidesPerView: 1.85,
          spaceBetween: 18
        },
        990: {
          slidesPerView: 2.15,
          spaceBetween: 22
        },
        1200: {
          slidesPerView: 2.2,
          spaceBetween: 24
        }
      },
      navigation: {
        prevEl: prev,
        nextEl: next
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'السابق',
        nextSlideMessage: 'التالي'
      }
    });

    root._allinoneSwiper = swiper;
  }

  function boot() {
    whenSwiper(function (Swiper) {
      document.querySelectorAll('[data-allinone361]').forEach(function (root) {
        initCarousel(root, Swiper);
      });
    });
  }

  ready(boot);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-allinone361]')
      : null;
    if (!root && event.target && event.target.matches && event.target.matches('[data-allinone361]')) {
      root = event.target;
    }
    if (!root) return;
    if (root._allinoneSwiper) {
      root._allinoneSwiper.destroy(true, true);
      root._allinoneSwiper = null;
    }
    boot();
  });
})();
